export const getters = {
  mfaEnabled: (state) => {
    return state.mfaMethods.some(mfaMethod => mfaMethod.enabled)
  },
  smsMfaEnabled: (state) => {
    return state.mfaMethods.find(mfaMethod => mfaMethod.type === state.mfaTypes.SMS).enabled
  }
}
